import { c as _c } from "react/compiler-runtime";
import { getUploadImageKey } from '@onefootprint/core';
import type { DocumentUpload } from '@onefootprint/request-types/dashboard';
import { useObjectUrl } from '@onefootprint/ui';
import type { EntityVault } from '@/types/vault';
const useUploadData = (upload, vault) => {
  const $ = _c(3);
  const base64Data = (vault[getUploadImageKey(upload)] ?? vault[upload.identifier]) as string;
  const {
    objectUrl,
    mimeType
  } = useObjectUrl(base64Data);
  const isPdf = mimeType === "application/pdf";
  let t0;
  if ($[0] !== isPdf || $[1] !== objectUrl) {
    t0 = {
      objectUrl,
      isPdf
    };
    $[0] = isPdf;
    $[1] = objectUrl;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};
export default useUploadData;